import type { SaleOrder, SaleOrderLine, SaleOrderWithLines } from '@/types/odoo';
import { OfferteContent } from './OfferteContent';

interface OfferteTabProps {
  saleOrders: SaleOrderWithLines[];
  saleOrder: SaleOrder | null;       // backward compat fallback
  lines: SaleOrderLine[];            // backward compat fallback
  partnerWarning?: string | null;
}

/**
 * Standalone offerte tab (ProjectView + WarehouseWerfDetailView). Thin wrapper over
 * the shared `OfferteContent` — the same renderer also powers the Dashboard's
 * DashboardOfferteSection, so the tab can be fully retired without losing the UI.
 */
export function OfferteTab({ saleOrders, saleOrder, lines, partnerWarning }: OfferteTabProps) {
  return (
    <OfferteContent
      saleOrders={saleOrders}
      saleOrder={saleOrder}
      lines={lines}
      partnerWarning={partnerWarning}
    />
  );
}
